export default [
  {
    id: 0,
    title: 'All Access Pass',
    text: 'Includes access to all events, receptions & workshops',
    features: [
      'Access to keynote speakers',
      'Transcripts and recordings of all events & workshops',
      'Access to quiet workspace lounge',
      'Provide targetted networking',
      'Gift bag',
      'Access to receptions with open bar',
      'Access to white papers (for post-conference communications)',
    ],
  },
  // {
  //   id: 1,
  //   title: 'Symposium Pass',
  //   text: 'All events on capitol hill & receptions',
  //   features: [
  //     'Access to keynote speakers',
  //     'Transcripts and recordings of all events & workshops',
  //     'Access to quiet wrokspace lounge',
  //     'Provide targetted networking',
  //     'Access to white papers (for post-conference communications)',
  //   ],
  // },
  // {
  //   id: 2,
  //   isDaily: true,
  //   title: 'Symposium Day Pass',
  //   text: 'Choose the day that better suits you',
  //   features: [
  //     'Educational program',
  //     'Cannabis educational reports',
  //     'Welcome reception dinner',
  //     'Gift bag',
  //     'Access to keynote speakers',
  //     'Transcripts and recordings of day\'s events & workshops',
  //   ],
  // },
  // {
  //   id: 3,
  //   isDaily: true,
  //   title: 'Power Networking Day Pass',
  //   text: 'Choose an evening that better suits you',
  //   features: [
  //     'Dinner networking',
  //     'Gift bag',
  //     'Assistance with meeting with participants u.s. rep. and u.s. senator staff',
  //   ],
  // },
  // {
  //   id: 4,
  //   title: 'Private Pass',
  //   text: 'Includes all receptions and power networking events off capitol hill',
  //   asterix: 'excludes symposium'
  // },
  // {
  //   id: 5,
  //   isDaily: true,
  //   title: 'Reception Pass',
  //   text: 'Choose the day that better suits you',
  //   features: [
  //     'Keynote presentation',
  //     'Open bar',
  //     'Food & beverage',
  //   ],
  // },
  // {
  //   id: 6,
  //   isDaily: true,
  //   title: 'Workshops',
  //   text: 'includes all workshops plus',
  //   features: [
  //     'Lunch',
  //     'Power networking',
  //     'Gift bag',
  //     'Transcripts and recordings of day\'s events & workshops',
  //   ],
  // },
]
